/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { COSTUME_INVENTORY_REPORT } from "../graphql/costumeInventoryReport.query";
import { GET_PRESENTATIONS } from "../graphql/getPresentations.query";
import { pretty } from "@vlinder-web/utils-react";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICostumeInventoryReportMethods extends IPluginMethodMap {
  costumeInventoryReport(args: any): Promise<any>;
}

export class CostumeInventoryReportService implements IAgentPlugin {
  readonly methods: ICostumeInventoryReportMethods;

  constructor() {
    this.methods = {
      costumeInventoryReport: this.costumeInventoryReport.bind(this),
    };
  }

  async costumeInventoryReport(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    let filters = {};
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              status: {
                eq: "active",
              }
            },
          },
          fetchPolicy: "network-only",
        });
        const defaultPresentation =
          _res?.data?.getPresentations?.content[0]?.id;
        if (args?.pid === "") {
          args.pid = defaultPresentation;
        }
        filters = {
          presentation: {
            eq: args.pid
          }
        }
        if (args?.sectionId && args?.sectionId !== null && args?.sectionId !== "") {
          filters = {
            ...filters,
            section: {
              eq: args?.sectionId
            }
          }
        }
        if (args?.sectionOptionId && args?.sectionOptionId !== null && args?.sectionOptionId !== "") {
          filters = {
            ...filters,
            _id: {
              eq: args?.sectionOptionId
            }
          }
        }
        const res = await client.query({
          query: COSTUME_INVENTORY_REPORT,
          variables: {
            filters: filters,
          },
          fetchPolicy: "network-only",
        });
        return res;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  // private convertCriteria(criteria : any) {
  //   const result: any = {};
  //   for (const key in criteria) {
  //     result[key] = { contains: criteria[key] };
  //   }
  //   return result;
  // }
}
